import { makeStyles, Theme, } from '@material-ui/core';

import loggedIcon from 'assets/icons/icon_login_on.svg';
import unloggedIcon from 'assets/icons/icon_login_off.svg';

const iconSize = 35;

type Props = {
    hasAccount: boolean,
};

// TODO PB Fix typing.
export const makeTypographyIconStyles = makeStyles<any, any>((theme: Theme) => ({
    root: ({ hasAccount, }: Props) => ({
        position: 'relative',

        '&::before': {
            content: "''",
            position: 'absolute',
            display: 'block',
            backgroundImage: `url(${hasAccount ? loggedIcon : unloggedIcon})`,
            backgroundSize: `${iconSize}px ${iconSize}px`,
            height: iconSize,
            width: iconSize,
            left: -38,
            top: -5,

            [theme.breakpoints.down('xs')]: {
                display: 'none',
            },
        },
    }),
}), { index: 1, });
